import { useLang } from "@/contexts/LanguageContext";
import { t } from "@/translations";

export default function AboutSection() {
  const { lang } = useLang();
  const tr = t[lang].about;

  return (
    <section className="w-full py-16 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6 flex flex-col lg:flex-row gap-12 items-start">
        {/* Left column */}
        <div className="flex-1 flex flex-col gap-6">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 leading-snug">
            {tr.heading1}
          </h2>
          <p className="text-gray-600 text-base leading-relaxed">{tr.body1}</p>
          <h3 className="text-xl md:text-2xl font-bold text-gray-900 leading-snug mt-2">
            {tr.heading2}
          </h3>
          <p className="text-gray-600 text-base leading-relaxed">{tr.body2}</p>
        </div>

        {/* Right column — infographic image */}
        <div className="w-full lg:w-[420px] flex-shrink-0">
          <img
            src="https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/6c0cc4dd92b9ab877826dacaa76d82ed.jpg/s/s1200x/a/47075/sc/392"
            alt="ABASCHOOL"
            className="w-full h-auto object-top rounded-lg"
          />
        </div>
      </div>
    </section>
  );
}
